omadapp.controllers.scenes.common_question_methods = {
	kill:function() {
    	var t = this;
    	t.$page.remove()
    },

    
    setPrev: function(scene) {
        var t = this
        t.prevScene = scene
        t.updateNav()
    },

    setNext: function(scene) {
        var t = this
        t.nextScene = scene
        t.updateNav()
    },

    updateNav:function() {
        var t = this;
        var $ = jQuery
        var $prev = t.$page.find(".js_prev")
        var $next = t.$page.find(".js_next")
        if (t.prevScene) {
            $prev.removeClass("disabled")
        } else {
            $prev.addClass("disabled")
        }
        if (t.nextScene) {
            $next.removeClass("disabled")
        } else {
            $next.addClass("disabled")
        }
    },
    initialize:function() {

    },
    
}